<div class="uk-modal uk-flex uk-open">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical uk-background-default uk-text-center">
    <img width="150" height="130" uk-svg="" src="/assets/images/icon/error-icon.svg" hidden="">
    <h3>เกิดข้อผิดพลาด</h3>
    <p class="uk-margin-medium-bottom">เกิดข้อผิดพลาดชั่วคราวของระบบ กรุณารอสักครู่และทำรายการใหม่อีกครั้ง</p>
  </div>
</div>